import { useTranslation } from 'react-i18next';
import { useGetCatalogQuery, useWorkspaceActivityQuery, useWorkspaceRecordsQuery } from '@platform/state/api';
import { ActivityFeedRow } from './ActivityFeedRow';
import { ActivityRow } from './ActivityRow';
import type { IHomeCardProps } from './IHomeCardProps';
import { mainRecordTypes } from './mainRecordTypes';

const SHOWN = 8;

/**
 * «Нещодавня активність» Головної (прототип v4 G:L1566–1590): 8 найновіших подій стрічки простору (GET /workspaces/{id}/activity) —
 * створення, зміни полів і статусів, коментарі, зв'язки. Сервер без стрічки — наближення: 8 нещодавно оновлених записів головних таблиць
 * з останньою подією історії кожного.
 */
export function ActivityCard({ ws }: IHomeCardProps) {
  const { t } = useTranslation();
  const { data: feed } = useWorkspaceActivityQuery({ ws, limit: SHOWN }, { skip: !ws });
  const fallback = feed?.available === false;
  const { data: catalog } = useGetCatalogQuery({ workspaceId: ws });
  const { data } = useWorkspaceRecordsQuery({ ws, types: mainRecordTypes(catalog) }, { skip: !catalog || !fallback });
  const recent = [...(data?.items ?? [])].sort((a, b) => Date.parse(b.updatedAt) - Date.parse(a.updatedAt)).slice(0, SHOWN);
  const empty = fallback ? !!data && !recent.length : !!feed && !feed.items.length;
  return (
    <section className="hp-card" aria-label={t('homePage.activity')}>
      <div className="hp-card__head"><span>{t('homePage.activity')}</span></div>
      {!fallback && feed?.items.slice(0, SHOWN).map((item) => <ActivityFeedRow key={item.id} item={item} />)}
      {fallback && recent.map((r) => <ActivityRow key={`${r.recordType}:${r.id}`} record={r} />)}
      {empty && <div className="hp-empty">{t('homePage.nothingRecent')}</div>}
    </section>
  );
}
